import { Injectable } from '@angular/core';
import { Usuario, Usuario2 } from '../../models/usuario.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';


@Injectable()
export class ReportesService {

  usuario: Usuario;
  token: string;
  usuario2: Usuario2;
  idUsuario: string;

  constructor(
    public http: HttpClient,
    public router: Router
  ) {
  }

  getReporteFacturas() {

    const url = `${environment.URL_SERVICIOS}/reports/general_report_invoices`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getReportecc_invoices(idc, dateFrom, dateTo) {

    const url = `${environment.URL_SERVICIOS}/reports/cc_invoices?company_id=${idc}&date_from=${dateFrom}&date_to=${dateTo}`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  sendAccountStatus(params) {

    const url = `${environment.URL_SERVICIOS}/send_mail_estado_cuenta?`;
    return this.http.post(url, params).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getInvoicesExpiration(idc) {

    const url = `${environment.URL_SERVICIOS}/reports/invoices_expiration?company_id=${idc}`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getReporteSolicitudesFondeo() {
    const url = `${environment.URL_SERVICIOS}/reports/general_report_funding_requests`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getReporteDetalleFactura(id) {

    const url = `${environment.URL_SERVICIOS}/invoices/${id}/invoice_details`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return this.crearArregloDetalleFactura(resp);
      })
    );

  }

  crearArregloDetalleFactura(optionsObj: any) {

    const detalles: any[] = [];
    const resul: any[] = [];

    if (optionsObj === null) { return []; }
    Object.keys(optionsObj).forEach(key => {
      const detalle: any = optionsObj[key];
      detalles.push(detalle);
    });
    // tslint:disable-next-line: forin
    for (const prop in detalles[0]) {
      //  console.log( usuarios[0][prop].attributes );
      resul.push(detalles[0][prop].attributes);
    }

    return resul;
  }

  getReporteDetalleSolicitud(id) {

    const url = `${environment.URL_SERVICIOS}/requests/${id}/request_details`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return this.crearArregloDetalleSolicitud(resp);
      })
    );

  }

  crearArregloDetalleSolicitud(optionsObj: any) {

    const detalles: any[] = [];
    const resul: any[] = [];

    if (optionsObj === null) { return []; }
    Object.keys(optionsObj).forEach(key => {
      const detalle: any = optionsObj[key];
      detalles.push(detalle);
    });
    // tslint:disable-next-line: forin
    for (const prop in detalles[0]) {
      //  console.log( usuarios[0][prop].attributes );
      resul.push(detalles[0][prop].attributes);
    }

    return resul;
  }

  getReporteSolicitudes() {

    const url = `${environment.URL_SERVICIOS}/reports/general_report_requests`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getReporteDaily(date, general_report) {

    const url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/daily_operations?general_report=${general_report}`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getReporteDailyExtended(date, general_report) {

    const url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/daily_operations_extended?general_report=${general_report}`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getCompanyRFC(contributorId) {

    const url = `${environment.URL_SERVICIOS}/reports/contributor_id/${contributorId}/get_rfc_from_contributor`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getBanorte(date, type, empresa) {

    let url;
    if(empresa === 'na'){
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/layout_banorte/${type}`;
    }else{
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/layout_banorte/${type}/company_id/${empresa}`;
    }

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getMonex(date, empresa) {
    let url;
    if(empresa === 'na'){
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/layout_monex`;
    }else{
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/layout_monex/company_id/${empresa}`;
    }

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getStp(date, type, empresa) {

    let url;
    if(empresa === 'na'){
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/layout_stp/${type}`;
    }else{
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/layout_stp/${type}/company_id/${empresa}`;
    }

    console.log(url);
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getBanregio(date,currency, type, empresa) {
    let url;
    if(empresa === 'na'){
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/currency/${currency}/layout_banregio/${type}`;
    }else{
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/currency/${currency}/layout_banregio/${type}/company_id/${empresa}`;
    }
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getMiFielBalance() {

    var link = environment.URL_SERVICIOS.replace('/api/v1', '');
    const url = `${link}/get_mifiel_balance?`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      }
      )
    );

  }

  getpayment_with_recourse_companies() {

    const url = `${environment.URL_SERVICIOS}/reports/payment_with_recourse_companies`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      }
      )
    );

  }

  getBase(date, currency, type, empresa) {
    let url;
    if(empresa === 'na'){
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/currency/${currency}/layout_base/${type}`;
    }else{
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/currency/${currency}/layout_base/${type}/company_id/${empresa}`;
    }

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

    getBaseAgrupa(date, currency, type, empresa) {
    let url;
    if(empresa === 'na'){
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/currency/${currency}/layout_base/${type}/true`;
    }else{
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/currency/${currency}/layout_base/${type}/true/company_id/${empresa}`;
    }
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getBbva(date, currency, type, empresa) {
    let url;
    if(empresa === 'na'){
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/currency/${currency}/layout_bbva/${type}`;
    }else{
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/currency/${currency}/layout_bbva/${type}/company_id/${empresa}`;
    }
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getGeneralParam(param){
    const url = `${environment.URL_SERVICIOS}/get_general_param?key=${param}`;
    return this.http.get(url);
  }

  getBaseAforo(date, currency, idc) {

    const url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/currency/${currency}/company_id/${idc}/layout_base_aforo`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getBaseRebate(date, currency, idc) {

    const url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/currency/${currency}/company_id/${idc}/layout_base_rebate`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getBancrea(date, type, empresa) {
    let url;
    if(empresa === 'na'){
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/layout_bancrea/${type}`;
    }else{
      url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/layout_bancrea/${type}/company_id/${empresa}`;
    }
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getCompanyPayments(date, idc) {

    const url = `${environment.URL_SERVICIOS}/reports/report_date/${date}/company_id/${idc}/company_payments`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      }
      )
    );

  }

  getOperatedInvoices(params) {

    const url = `${environment.URL_SERVICIOS}/reports/mail_invoice_fliben?company_id=${params.company_id}&used_date=${params.used_date}`;

    return this.http.get(url, params).pipe(
      map((resp: any) => {
        return resp;
      }
      )
    );

  }

  getCompanyPaymentsw(date, idc) {

    const url = `${environment.URL_SERVICIOS}/reports/report_date/${date}/supplier_id/${idc}/company_payments`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      }
      )
    );

  }

  getCompanyPaymentsusd(date, idc) {

    const url = `${environment.URL_SERVICIOS}/reports/report_date/${date}/company_id/${idc}/usd_company_payments`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      }
      )
    );

  }

  getCompanyPaymentswusd(date, idc) {

    const url = `${environment.URL_SERVICIOS}/reports/report_date/${date}/supplier_id/${idc}/usd_company_payments`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      }
      )
    );

  }

  getCompapanyes() {

    const url = `${environment.URL_SERVICIOS}/reports/payment_companies`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getCompapanyesw() {

    const url = `${environment.URL_SERVICIOS}/reports/payment_deleg_suppliers`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );

  }

  getCFDIS() {
    const url = `${environment.URL_SERVICIOS}/reports/invoice_cfdis`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getDirectorReportResume() {
    const url = `${environment.URL_SERVICIOS}/reports/director_report_resume`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getDirectorDetailPayments() {
    const url = `${environment.URL_SERVICIOS}/reports/director_report_detail_payments`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getDirectorDetailDiscounts() {
    const url = `${environment.URL_SERVICIOS}/reports/director_report_detail_discounts`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getPaymentsCFDIS(valores: any) {
    const url = `${environment.URL_SERVICIOS}/reports/payment_cfdis?pi_type=${valores.pago}&date_from=${valores.desde}&date_to=${valores.hasta}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getPaymentsNoDescontada(curr: string, cid: string) {
    const url = `${environment.URL_SERVICIOS}/reports/company_id/${cid}/currency/${curr}/payment_company_invoices_nd`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getPaymentsDescontadaSinFondeo(curr: string, cid: string) {
    const url = `${environment.URL_SERVICIOS}/reports/company_id/${cid}/currency/${curr}/payment_company_invoices_req`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getPaymentsDescontadaConFondeo(curr: string, cid: string) {
    const url = `${environment.URL_SERVICIOS}/reports/company_id/${cid}/currency/${curr}/payment_company_invoices_fun`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }
  
  borraSolicitudFondeo( idsf ) {
    const url = `${environment.URL_SERVICIOS}/funding_requests/funding_request_id/${idsf}/drop_funding_requests`;
    return this.http.delete( url ).pipe(
      map( (resp: any) => {
        return resp;
      }));
    }
    
    getPendientes() {
      const url = `${environment.URL_SERVICIOS}/reports/pending_registries`;
      return this.http.get(url).pipe(
        map((resp: any) => {
          return resp;
        })
      );
    }
}
